import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { deviceDetected } from 'planoplan-ui-kit/core/device-detected';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { CustomLink } from '@components/Custom-Link';
import { MAIN_MENU } from '@constants/menu';
import { Points } from '@styles';

export const Navigation = ({ query = {}, isDarkMode = false }) => {
  const { nextRoute } = query;
  const { locale } = useSelector((state) => state.settings);
  const mainMenu = MAIN_MENU.filter((i) => i.locale.includes(locale) && i.isHeader).sort(
    (a, b) => a.headerOrder - b.headerOrder
  );

  return (
    <View isDarkMode={isDarkMode}>
      <MainMenu>
        {mainMenu.map(({ href, link, key }) => (
          <MainMenuItem key={key} isMobile={deviceDetected.isMobile} isActive={nextRoute === href}>
            <CustomLink href={href} link={link && link(locale)} translateKey={key} useHtmlTranslateKey />
          </MainMenuItem>
        ))}
      </MainMenu>
    </View>
  );
};

const View = styled.nav`
  margin-left: auto;
  font-size: 18px;
  line-height: 22px;
  color: ${(p) => (p.isDarkMode === true ? `${Colors.white}` : `${Colors.coal}`)};
  align-items: center;
  display: none;

  @media ${Points.tablet_landscape} {
    display: flex;
  }
`;

const MainMenu = styled.ul`
  ${Mixins.resetList()};
  display: flex;
  gap: 20px;
`;

const MainMenuItem = styled.li`

  a {
    ${Mixins.transition('color')};
    ${Mixins.resetLink()};
    color: ${({ isActive }) => isActive && Colors.electric_blue};
    white-space: nowrap;

    &:hover {
      color: ${({ isMobile }) => !isMobile && Colors.electric_blue};
    }
  }
`;
